import { tempMeeApi } from '~/services/api';
import { scopedHeaders } from './scopedHeaders';
import type { IOfficeMissingInfoCredentialsPatch } from '../types/OfficeMissingInfo.api';

export const updateUserCredentials = async (
  payload: IOfficeMissingInfoCredentialsPatch,
  officeId?: string | null,
): Promise<void> => {
  const headers = await scopedHeaders(officeId);
  await tempMeeApi.patch('/credential-service/user/credentials', payload, { headers });
};
